var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileIconsHamburgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;clip-rule:evenodd;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#516983;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-247.56,313.88a1,1,0,0,1,.33.3c.24.25.26.31.08.61-.91,1.46-9.94,10.84-10.94,11.35a1.08,1.08,0,0,1-.67.12,26.76,26.76,0,0,1-3.52-3.74c-1.05-1.24-1.13-1.49-.61-1.77.24-.13.52.05,2,1.34l2,1.69c.24.2.51,0,3.54-3,1.81-1.76,4.28-4,5.49-5.06S-247.62,313.88-247.56,313.88Zm-13.09-2.48a13.2,13.2,0,0,1,6.66,1c1,.44,1.2.75.88,1.09s-.34.18-1.55-.24a8.13,8.13,0,0,0-3-.5,9.37,9.37,0,0,0-4.83.85,10.46,10.46,0,0,0-5.91,6.8,12.46,12.46,0,0,0,.06,5.6,10.42,10.42,0,0,0,8.49,7.27,10.72,10.72,0,0,0,9.79-3.89,10.62,10.62,0,0,0,2.27-6.5c.05-1.74.16-2.12.6-1.84s.49,1,.42,3a9.65,9.65,0,0,1-1.11,4.69,12.33,12.33,0,0,1-7.88,6.28,12.54,12.54,0,0,1-9.23-1.43,13.15,13.15,0,0,1-4.85-5.67,12.12,12.12,0,0,1,1.71-12.13A12.63,12.63,0,0,1-260.65,311.4Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.2,5H.8V3H23.2Zm0,6H.8v2H23.2Zm0,8H.8v2H23.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIconsHamburgerMenu);
export default __webpack_public_path__ + "static/media/Mobile-Icons_hamburger-menu.acc0e4f48a109fdd2f9c0bc8bcf22edd.svg";
export { ForwardRef as ReactComponent };